import * as React from "react";
import {ChangeEvent} from "react";
import MaskedInput from "react-text-mask";
import {ClickableProps} from "../../../../components/common/props/ClickableProps";
import {FocusableProps} from "../../../../components/common/props/FocusableProps";
import {EditableProps} from "../../../../components/common/props/EditableProps";
import {PlaceholderProps} from "../../../../components/common/props/PlaceholderProps";
import {DisableableProps} from "../../../../components/common/props/DisableableProps";
import {none, option, Option} from "ts-option";
import {BlurableProps} from "../../../../components/common/props/BlurableProps";
import "./input.scss";

interface ComponentProps {
	/**
	 * Input change callback.
	 */
	onChange: (value: Option<string>) => void;
	/**
	 * Input value.
	 */
	value?: Option<string>;
	/**
	 * Array of regexp masks.
	 */
	mask: Array<string | RegExp>;
	/**
	 * Placeholder.
	 */
	placeholder?: string;
}

type Props =
	ComponentProps
	& FocusableProps
	& ClickableProps
	& EditableProps
	& DisableableProps
	& PlaceholderProps
	& BlurableProps;

export default class MaskedTextInput extends React.Component<Props, {}> {
	render() {
		return (
			<MaskedInput
				mask={this.props.mask}
				className="a-input"
				placeholder={this.props.placeholder}
				guide={true}
				onClick={this.props.onClick}
				onChange={this.onChange}
				value={this.props.value.orNull}
				onFocus={this.props.onFocus}
				onBlur={this.props.onBlur}
				disabled={this.props.disabled}
				readOnly={this.props.readonly}/>
		);
	}

	/**
	 * On value change callback.
	 * @param {React.ChangeEvent<HTMLInputElement>} evt
	 */
	onChange = (evt: ChangeEvent<HTMLInputElement>) => {
		const value = evt.target.value;
		this.props.onChange(!this.props.disabled && value.length ? option(value) : none);
	};
};
